import NotificationsSettingsPage from "@/pages/settings/NotificationsSettingsPage";

/**
 * Personal notification preferences (same behavior as legacy /settings/notifications).
 * Rendered in the admin shell for the unified “My Settings” IA.
 */
export default function AdministrationNotificationsPage() {
  return <NotificationsSettingsPage />;
}
